import React from 'react';
import { Button, Divider, Typography } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';

export default function InitialOptions({ onGoogleLogin, onEmailLogin }) {
    return (
        <>
            <Button
                variant="outlined"
                startIcon={<GoogleIcon sx={{ color: '#4285F4' }} />}
                onClick={onGoogleLogin}
                sx={{ 
                    width: '300px',
                    textTransform: 'none',
                    borderColor: '#dadce0',
                    color: '#3c4043',
                    '&:hover': {
                        borderColor: '#dadce0',
                        backgroundColor: '#f8f9fa'
                    }
                }}
            >
                Continue with Google
            </Button>
            
            <Divider sx={{ width: '100%', my: 2 }}>
                <Typography color="textSecondary">or</Typography>
            </Divider>
            
            <Button
                variant="outlined"
                onClick={onEmailLogin}
                sx={{ 
                    width: '300px', 
                    textTransform: 'none',
                    color: '#3c4043',
                    borderColor: '#dadce0',
                }}
            >
                Sign in with Email
            </Button>
        </>
    );
} 